const deliveryRoutes = {
	clubs: {
		path: '/clubs',
		name: 'Clubs',
		component: () => import('@/views/Clubs.vue'),
		meta: { title: 'Clubs' }
	},
	pendientes: {
		path: '/pendientes',
		name: 'Pendientes',
		component: () => import('@/views/Pendientes.vue'),
		meta: { title: 'Pendientes' }
	},
	entregas: {
		path: '/entregas',
		name: 'Entregas',
		component: () => import('@/views/Entregas.vue'),
		meta: { title: 'Entregas' }
	},
	entregasRetail: {
		path: '/entregas-retail',
		name: 'EntregasRetail',
		component: () => import('@/views/Entregas.vue'),
		meta: { title: 'PickUp' }
	}
}

export default deliveryRoutes
